import React, { useRef, useState } from "react";
import { StyleSheet } from "react-native";
import { Modal } from "~/components/Modal";
import { Pressable } from "~/components/Pressable";
import { ErrorViewV2 } from "~/components/V2/ErrorViewV2";
import { View } from "~/components/View";
import { styleConstants } from "~/style/styleConstants";
import { shadow } from "~/utils/shadow";
import { ButtonV2 } from "../Button";
import { errorAlertContextV2 } from "./errorAlertContextV2";

const S = StyleSheet.create({
  button: {
    paddingHorizontal: 40,
  },
});

export const ErrorAlertProviderV2 = ({
  children,
}: {
  children: React.ReactNode;
}) => {
  const [error, setError] = useState<unknown | undefined>(undefined);
  const [title, setTitle] = useState<string | undefined>(undefined);
  const [description, setDescription] = useState<string | undefined>(undefined);
  const [buttonText, setButtonText] = useState<string | undefined>(undefined);
  const onButtonPressRef = useRef<(() => void) | undefined>(undefined);
  const [showAdditionalHelp, setShowAdditionalHelp] = useState<boolean>(false);

  return (
    <>
      <errorAlertContextV2.Provider
        value={(
          error,
          title,
          description,
          buttonText,
          onButtonPress,
          showAdditionalHelp,
        ) => {
          setError(error);
          setTitle(title);
          setDescription(description);
          setButtonText(buttonText);
          if (onButtonPress) {
            onButtonPressRef.current = onButtonPress;
          }
          setShowAdditionalHelp(!!showAdditionalHelp);
        }}
      >
        {children}
      </errorAlertContextV2.Provider>
      {!!error && (
        <Modal>
          <Pressable
            style={StyleSheet.absoluteFill}
            colorBackgroundBackdrop
            onPress={() => {
              setError(undefined);
            }}
          />
          <View
            flex
            paddingHorizontalLarge
            paddingVerticalExtraLarge
            centerContent
            style={{ pointerEvents: "none" }}
          >
            <View
              style={{
                backgroundColor: styleConstants.colorBackgroundWhite,
                borderRadius: styleConstants.borderRadiusMedium,
                ...shadow(4),
                maxWidth: 600,
                width: "100%",
                paddingVertical: 28,
                pointerEvents: "auto",
              }}
            >
              <ErrorViewV2
                error={error}
                title={title}
                body={description}
                showAdditionalHelp={showAdditionalHelp}
              />

              {!showAdditionalHelp && (
                <View paddingExtraLarge alignItemsCenter>
                  <ButtonV2
                    title={
                      buttonText ||
                      intl.formatMessage({
                        defaultMessage: "Try again",
                        id: "mz0/QX",
                        description:
                          "Button on error alert modal that closes the modal",
                      })
                    }
                    onPress={() => {
                      onButtonPressRef.current?.();
                      setError(undefined);
                    }}
                    style={S.button}
                  />
                </View>
              )}
            </View>
          </View>
        </Modal>
      )}
    </>
  );
};
